var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
function Skeleton(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx("div", Object.assign({ 
        // NOTE: this project does not define shadcn's `--muted` token, so `bg-muted` can be transparent.
        // Use our design tokens to ensure skeletons are visible in both light/dark themes.
        className: cn(
        // IMPORTANT: Tailwind opacity modifiers (e.g. `/80`) don't work with our CSS-var colors
        // because they are defined as plain `var(...)` strings. Keep it solid so pulse is visible.
        "animate-pulse rounded-md bg-background-neutral-3", className) }, props)));
}
export { Skeleton };
